import { useState } from "react";
import { styled } from "@mui/material/styles";

import { Card, Typography } from "@mui/material";
import { LinkButton } from "~/common/components/Link";
import { C_SURFACE } from "~/common/components/icon/Colors";
import MMDDialog from "./MMDDialog";
import { useTranslation } from "react-i18next";
import BoxAdd from "~/common/icons/BoxAdd";
import { useIsMinDesktopSize } from "~/common/hooks/useMediaQuery";

export default function MMDAssistant(props: { isPDP?: boolean; marketDesignation: string }) {
  const [showMMDAssistant, setShowMMDAssistant] = useState(false);

  const { t } = useTranslation();

  const { isPDP = true, marketDesignation } = props;

  const isDesktop = useIsMinDesktopSize();

  if (!isDesktop) {
    return null;
  }

  return (
    <>
      <StyledCard variant={"elevation"} elevation={1} isPDP={isPDP}>
        <BoxAdd fontSize="large" />
        <Typography variant={"bodyLarge"} sx={{ ml: 1, mr: { tablet: 2 } }}>
          {t("feature.mmd.assistant.message")}
        </Typography>
        <LinkButton
          onClick={() => {
            setShowMMDAssistant(true);
          }}
        >
          {t("feature.mmd.assistant.seemore")}
        </LinkButton>
      </StyledCard>

      <MMDDialog
        open={showMMDAssistant}
        onClose={() => setShowMMDAssistant(false)}
        marketDesignation={marketDesignation}
      />
    </>
  );
}

const StyledCard = styled(Card, {
  shouldForwardProp: (prop) => prop !== "isPDP",
})<{ isPDP: boolean }>(({ theme, isPDP }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: C_SURFACE,
  padding: "16px",
  margin: isPDP ? 0 : 16,
  marginTop: isPDP ? 0 : 8,
  [theme.breakpoints.down("tablet")]: {
    display: "grid",
    gridTemplateColumns: "auto 1fr",
    gridTemplateRows: "auto auto",
    placeItems: "center",
    "& > svg": {
      gridRow: "1 / 3",
    },
  },
}));
